import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{format-range @record.minValue @record.maxValue @record.unit}}")